<template>
  <v-app id="app-wrapper">
    <!-- Botón Burger Sticky y Mini Logo-->
    <div class="burger">
      <div
        @click="
          drawer = !drawer;
          burgerCruz();
        "
        class="burger-btn emboss-txt"
        id="myDIV"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <v-img :src="image_src2" class="logo-menu3" contain></v-img>
    </div>

    <!-- Menú-->
    <v-navigation-drawer
      class="transicion"
      v-model="drawer"
      fixed
      width="100%"
      v-bind:style="{ backgroundColor: bgColorMenu }"
    >
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-row class="img-row">
              <v-img :src="image_src" class="logo-menu" contain></v-img>
            </v-row>
            <v-row class="menu-titulos">
              <v-card
                color="rgba(0, 0, 0, 0)"
                router
                exact
                outlined
                tile
                to="/alquimistas"
                @click="
                  drawer = false;
                  burgerCruz();
                  cambiarColorHeader1();
                "
                @mouseover="mouseHover1()"
                @mouseleave="mouseLeave()"
                style="border: 0px; text-decoration: none;"
              >
                <v-row :align="alignment" class="menu-item">
                  <div class="hline"></div>
                  <v-card-title
                    style="padding:0em; font-size:calc(15.5px + .78125vw); font-weight:600; color:black; text-decoration: none;"
                    >Alquimistas & Colaboradores</v-card-title
                  >
                </v-row>
              </v-card>
              <v-card
                color="rgba(0, 0, 0, 0)"
                router
                exact
                outlined
                tile
                to="/manifiesto"
                @click="
                  drawer = false;
                  burgerCruz();
                  cambiarColorHeader2();
                "
                @mouseover="mouseHover2()"
                @mouseleave="mouseLeave()"
                style="border: 0px; text-decoration: none;"
              >
                <v-row :align="alignment" class="menu-item">
                  <div class="hline"></div>
                  <v-card-title
                    style="padding:0em; font-size:calc(15.5px + .78125vw); font-weight:600; color:black; text-decoration: none;"
                    >Manifiesto</v-card-title
                  >
                </v-row>
              </v-card>
              <v-card
                color="rgba(0, 0, 0, 0)"
                router
                exact
                outlined
                tile
                to="/proyectos"
                @click="
                  drawer = false;
                  burgerCruz();
                  cambiarColorHeader3();
                "
                @mouseover="mouseHover3()"
                @mouseleave="mouseLeave()"
                style="border: 0px; text-decoration: none;"
              >
                <v-row :align="alignment" class="menu-item">
                  <div class="hline"></div>
                  <v-card-title
                    style="padding:0em; font-size:calc(15.5px + .78125vw); font-weight:600; color:black; text-decoration: none;"
                    >Proyectos</v-card-title
                  >
                </v-row>
              </v-card>
            </v-row>

            <div class="bottom">
              <div class="bottom-up">
                <div class="column1">
                  <div class="row2 ft ft_normal ft_white">
                    <span class="ft_small">Dirección:</span>
                    <a
                      target="_blank"
                      class="contacto"
                      href="https://goo.gl/maps/YxMRVkzL2wYsEQR38"
                      >Triana 861, Providencia</a
                    >
                  </div>
                  <div class="row2 ft ft_normal ft_white">
                    <span class="ft_small">Teléfono:</span>
                    <a class="contacto" href="tel:+56999918422" target="_blank"
                      >+56 9 9991 8422</a
                    >
                    <a
                      class="contacto telefono2"
                      href="tel:+56974505402"
                      target="_blank"
                      >+56 9 7450 5402</a
                    >
                  </div>
                  <div class="row2 ft ft_normal ft_white">
                    <span class="ft_small">E-mail:</span>
                    <a
                      target="_blank"
                      class="contacto"
                      href="mailto:info@colectivoalquimia.cl"
                      >info@colectivoalquimia.cl</a
                    >
                  </div>
                </div>
              </div>
              <div class="bottom-down">
                <a
                  href="https://www.instagram.com/colectivoalquimia/"
                  target="_blank"
                >
                  <v-icon
                    large
                    class="icon"
                    color="#372b5d"
                    target="_blank"
                    href="https://www.instagram.com/colectivoalquimia/"
                    >mdi-instagram</v-icon
                  >
                </a>
                <!--   <v-icon large class="icon" color="#372b5d">mdi-linkedin</v-icon> -->
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>

    <!-- Header-->
    <app-header
      ref="headerRef"
      style="z-index:5; position:absolute;"
    ></app-header>

    <!-- Content-->
    <v-content>
      <span v-touch:swipe="swipeHandler">
        <transition name="slide">
          <router-view ref="routerViewRef" class="mui-container" />
        </transition>
      </span>
    </v-content>
  </v-app>
</template>

<script>
import store from "./store";
import AppHeader from "./components/Header";

export default {
  name: "App",
  components: {
    AppHeader,
  },
  methods: {
    burgerCruz() {
      document.getElementById("myDIV").classList.toggle("change");
    },
    mouseHover1() {
      this.bgColorMenu = "#c8c7cc";
    },
    mouseHover2() {
      this.bgColorMenu = "#b8c9e3";
    },
    mouseHover3() {
      this.bgColorMenu = "#e6bda1";
    },
    mouseLeave() {
      this.bgColorMenu = "#ebf6f3";
    },
    cambiarColorHeader1() {
      this.bgColor = "#c8c7cc";
      this.$refs.headerRef.cambiarColor1();
    },
    cambiarColorHeader2() {
      this.bgColor = "#b8c9e3";
      this.$refs.headerRef.cambiarColor2();
    },
    cambiarColorHeader3() {
      this.bgColor = "#e6bda1";
      this.$refs.headerRef.cambiarColor3();
    },
    /* onScroll(e) {
      this.opHeader = 0;
      //console.log("e.srcElement.scrollTop: " + e.srcElement.scrollTop);
      console.log("isOnTop: " + this.$refs.routerViewRef.isOnTop());
      if (e.srcElement.scrollTop > 1 || !this.$refs.routerViewRef.isOnTop()) {
        this.isOnTop = false;
        this.$refs.headerRef.hideHeader();
      } else {
        this.$refs.headerRef.showHeader();
        this.isOnTop = true;
      
    },*/
    hideHeaderApp() {
      store.commit("esconder");
    },
    showHeaderApp() {
      store.commit("mostrar");
    },
    onMouse() {
      /*
      console.log("isOnTop: " + this.$refs.routerViewRef.isOnTop());
      if (!this.$refs.routerViewRef.isOnTop()) {
        this.isOnTop = false;
        this.$refs.headerRef.hideHeader();
      } else {
        this.$refs.headerRef.showHeader();
        this.isOnTop = true;
      }*/
    },
    swipeHandler(direction) {
      if (direction == "top") {
        this.isOnTop = false;
        store.commit("esconder");
      }
      /*
      if (this.$refs.routerViewRef.getSection() == "pro1") {
        if (direction == "bottom") {
          this.isOnTop = true;
          store.commit("mostrar");
        } else if (direction == "top") {
          this.isOnTop = false;
          store.commit("esconder");
        }
      }
      */
    },
    onClick() {
      /*
      if (this.$refs.routerViewRef.getSection() == "pro1") {
        if(store.state.headerIsVisible){
          this.isOnTop = false;
          store.commit('esconder');
        }
      }
      */
    },
    onWheel(e) {
      e;
      if (this.$refs.routerViewRef.getSection() == "pro1" && e.deltaY > 0) {
        this.isOnTop = false;
        store.commit("esconder");
      } else if (
        this.$refs.routerViewRef.getSection() == "pro1" &&
        e.deltaY < 0
      ) {
        this.isOnTop = true;
        store.commit("mostrar");
      }

      /*
      if (e.deltaY > 0) {
        this.isOnTop = false;
        this.$refs.headerRef.hideHeader();
      }else if (
        this.$refs.routerViewRef.getSection() == "pro1" &&
        e.deltaY < 0
      ) {
        this.isOnTop = true;
        this.$refs.headerRef.showHeader();
      }
       else if (this.$refs.routerViewRef.onLeave == true) {
        this.isOnTop = true;
        this.$refs.headerRef.showHeader();
      } else if (
        this.$refs.routerViewRef.getSection() == "section1api" &&
        e.deltaY < 0
      ) {
        this.isOnTop = true;
        this.$refs.headerRef.showHeader();
      } else if (
        this.$refs.routerViewRef.getSection() == "alq1" &&
        e.deltaY < 0
      ) {
        this.isOnTop = true;
        this.$refs.headerRef.showHeader();
      } else if (
        this.$refs.routerViewRef.getSection() == "man1" &&
        e.deltaY < 0
      ) {
        this.isOnTop = true;
        this.$refs.headerRef.showHeader();
      } else if (
        this.$refs.routerViewRef.getSection() == "pro1" &&
        e.deltaY < 0
      ) {
        this.isOnTop = true;
        this.$refs.headerRef.showHeader();
      } else {
        this.isOnTop = false;
        this.$refs.headerRef.hideHeader();
      }
      */
    },
  },
  computed: {
    revisarHeader() {
      if (this.loaded) {
        if (store.state.headerIsVisible) {
          this.$refs.headerRef.showHeader();
          return true;
        } else {
          this.$refs.headerRef.hideHeader();
          return false;
        }
      } else {
        return null;
      }
    },
  },
  watch: {
    revisarHeader() {
      // Our fancy notification (2).
    },
  },
  metaInfo: {
    title: "Colectivo Alquimia",
    titleTemplate: "%s ",
    htmlAttrs: {
      lang: "es",
      amp: true,
    },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Colectivo de Arquitectura e Interiorismo. Trabajamos de manera colaborativa y multidisciplinaria para diseñar espacios con identidad y atmósfera.",
      },
      {
        property: "og:title",
        content: "Colectivo Alquimia",
      },
      { property: "og:site_name", content: "Colectivo Alquimia" },
      { property: "og:type", content: "website" },
      { property: "og:image", content: "website" },
      { name: "robots", content: "index,follow" }
    ]
  },
  mounted() {
    this.loaded = true;
    this.$refs.headerRef.showHeader();
    window.addEventListener("click", this.onClick, true);
    window.addEventListener("scroll", this.onScroll, true);
    window.addEventListener("mousedown", this.onMouse, true);
    window.addEventListener("wheel", this.onWheel, true);
  },
  destroyed() {
    window.addEventListener("click", this.onClick, true);
    window.removeEventListener("scroll", this.onScroll, true);
    window.addEventListener("mousedown", this.onMouse, true);
    window.addEventListener("wheel", this.onWheel, true);
  },
  data: () => ({
    image_src: require("../src/assets/logo.png"),
    image_src2: require("../src/assets/logo2.png"),
    clipped: false,
    bgColor: "#ebf6f3",
    drawer: false,
    isOnTop: true,
    loaded: false,
    opHeader: 1,
    fixed: false,
    bgColorMenu: "#ebf6f3",
    bgc: {
      backgroundColor: "#345876",
    },
    showNav: false,
    alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
    alignment: "center",
    justifyAvailable: [
      "start",
      "center",
      "end",
      "space-around",
      "space-between",
    ],
    justify: "center",
    miniVariant: false,
    right: true,
    rightDrawer: false,
    title: "Vuetify.js",
  }),
};
</script>

<style>
@import "./assets/styles/main.css";

.section-1,
.section-2,
.section-3,
.section-4,
.section-5 {
  min-height: 100vh;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 1.5s cubic-bezier(0.0001, 0.00001, 0.00005, 0.0001);
}
.slide-enter {
  transform: translateY(100%);
}
.emboss-txt {
  transition: 0.95s cubic-bezier(0.55, 0, 0.1, 1);
  background-color: rgba(207, 207, 207, 0.1);
  position: relative;
  color: rgb(207, 207, 207);
  box-shadow: 
  /*3d layers*/ 0px 0px 1px rgb(167, 167, 167),
    0px 1px 1px rgb(167, 167, 167), 0px 2px 1px rgb(167, 167, 167),
    1px 1px 1px rgb(167, 167, 167), 1px 2px 1px rgb(167, 167, 167),
    1px 3px 1px rgb(167, 167, 167), 2px 2px 1px rgb(167, 167, 167),
    2px 3px 1px rgb(167, 167, 167), 2px 4px 1px rgb(167, 167, 167),
    1px 1px 3px rgba(0, 0, 0, 0.3), 1px 1px 7px rgba(0, 0, 0, 0.3),
    /*short soft bottom*/ 0px 2px 2px rgba(0, 0, 0, 0.2),
    /*left shadow*/ -2px 2px 10px rgba(0, 0, 0, 0.2),
    /*right shadow*/ 2px 2px 10px rgba(0, 0, 0, 0.2),
    /*white light*/ 1px 1px 120px rgba(255, 255, 255, 0.5);
  animation: cycle-color 5s linear infinite;
}
.emboss-txt::after {
  content: "";
  top: 0;
  left: 0;
  animation: cycle 10s linear infinite;
  box-shadow: 0px 0px 100px rgba(11, 124, 199, 0.5);
}
.emboss-txt:hover {
  transition: 0.95s cubic-bezier(0.55, 0, 0.1, 1);
  transform: rotate(180deg);
  left: 0;
}

@keyframes cycle {
  0% {
    box-shadow: 0px 0px 100px rgba(11, 124, 199, 0.5);
  }
  20% {
    box-shadow: 0px 0px 100px rgba(168, 11, 199, 0.5);
  }
  40% {
    box-shadow: 0px 0px 100px rgba(11, 199, 96, 0.5);
  }
  60% {
    box-shadow: 0px 0px 100px rgba(199, 11, 11, 0.5);
  }
  80% {
    box-shadow: 0px 0px 100px rgba(199, 96, 11, 0.5);
  }
}
@keyframes cycle-color {
  0% {
    background-color: rgba(207, 207, 207, 0.1);
  }
  20% {
    background-color: rgba(207, 207, 207, 0.15);
  }
  40% {
    background-color: rgba(207, 207, 207, 0.2);
  }
  60% {
    background-color: rgba(207, 207, 207, 0.15);
  }
  80% {
    background-color: rgba(207, 207, 207, 0.1);
  }
}
.aux {
  position: relative;
  z-index: 99;
}
#app-wrapper {
  display: flex;
  min-height: 100vh;
  padding: 0px;
  margin: 0px;
  flex-direction: column;
  overflow-x: hidden;
}
#cuerpo {
  transition: opacity 0.95s cubic-bezier(0.55, 0, 0.1, 1);
}

.mui-container {
  max-width: 100vw;
  max-height: 100vh;
  position: absolute;
  top: 0%;
  left: 0%;
  overflow: hidden;
}
.bckimg-menu {
  height: 100vh; /* You must set a specified height */
  top: 0%;
  left: 0%;
}

.hline {
  width: 40px;
  height: 2px;
  padding: 0px;
  margin: 0px;
  margin-left: 15px;
  padding-left: 5px;
  background: black;
}
.hline2 {
  width: 400px;
  height: 1px;
  padding: 0px;
  margin: 0px;
  margin-left: 15px;
  padding-left: 5px;
  background: black;
}
.burger {
  position: fixed;
  z-index: 999;
}
.burger-btn {
  width: 3.5em;
  height: 3.5em;
  padding: 1em;
  cursor: pointer;
  z-index: 999;
}
.burger-btn span {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: calc(100% - 2em);
  height: 2px;
  background: black;
  transition: 0.4s;
}
.burger-btn span:first-child {
  transform: translateY(-50%) translateX(-50%) translateY(-6px);
}
.burger-btn span:nth-child(2) {
  transform: translateY(-50%) translateX(-50%) scaleX(1);
}
.burger-btn span:nth-child(3) {
  transform: translateY(-50%) translateX(-50%) translateY(6px);
}
.change span:first-child {
  top: 50%;
  left: 15px;
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  transform: rotate(135deg);
}
.change span:nth-child(2) {
  opacity: 0;
  left: -10px;
}
.change span:nth-child(3) {
  top: 50%;
  left: 15px;
  -webkit-transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -o-transform: rotate(-135deg);
  transform: rotate(-135deg);
}
.bottom-down {
  display: flex;
  border-top: 1px solid black;
  justify-content: center;
  -webkit-box-pack: justify;
}
.ft_white {
  color: black;
}
.ft_normal {
  line-height: 1.5em;
  font-size: 15px;
}
.ft_small {
  line-height: 1.5em;
  font-size: calc(12.75px + 0.17813vw);
}
.ft {
  /*font-family: Sofia Pro,sans-serif;*/
  font-weight: 300;
}
.row2 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  height: 3vh;
}
.menu-item:hover {
  border-bottom: 0px !important;
  opacity: 1;
  text-decoration: none !important;
  font-weight: 800 !important;
}
.v-card__title:hover {
  border-bottom: 0px !important;
  opacity: 1;
  text-decoration: none !important;
  box-shadow: none;
}
.v-card__title:active {
  border-bottom: 0px !important;
  opacity: 1;
  text-decoration: none !important;
  box-shadow: none;
}
.contacto {
  transition: 725ms cubic-bezier(0.445, 0.05, 0.015, 1);
  transition: opacity 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  position: absolute;
  font-size: calc(12.75px + 0.17813vw);
  right: 0%;
  font-family: "Source-light";
}
.contacto:hover {
  transition: 725ms cubic-bezier(0.445, 0.05, 0.015, 1);
  transition: opacity 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  opacity: 0.7;
  cursor: pointer;
}
.icon {
  padding: 5px;
}
.icon:hover {
  cursor: pointer;
  opacity: 0.7;
}
@media (min-width: 960px) {
  .transicion {
    background-image: url("../src/assets/fondo-menu.png");
    /*background: linear-gradient(rgba(255,255,255,.5), rgba(255,255,255,.5)), url("../src/assets/fondo-menu.jpg");*/
    height: 100vh; /* You must set a specified height */
    top: 0%;
    left: 0%;
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    transition: 725ms cubic-bezier(0.445, 0.05, 0.015, 1);
    z-index: 20;
  }
  .transicion:hover {
    transition: 725ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .bottom {
    position: absolute;
    z-index: 1;
    display: block;
    width: 60%;
    left: 20%;
    bottom: 6vh;
  }
  .bottom-up {
    display: flex;
    margin-bottom: 0em;
    flex-wrap: wrap;
  }
  .column1 {
    width: 100%;
  }
  .row2 p {
    margin: 0;
    padding: 0;
    border: 0;
  }
  .bottom .column .row2 span {
    width: 30%;
  }
  .menu-titulos {
    top: 50%;
    align-content: center;
    justify-content: center;
    transition: opacity 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .menu-item {
    position: relative;
    margin-left: 5vw;
    opacity: 0.7;
    border-bottom: 0px !important;
    transition: opacity 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .img-row {
    padding-top: 20vh;
    padding-bottom: 10vh;
    left: 40%;
  }
  .logo-menu {
    width: 20vw;
    height: 20vh;
  }
  .logo-menu3 {
    position: relative;
    top: 0vh;
    left: -7vw;
    width: 18vw;
    height: 18vh;
  }
  .burger {
    z-index: 999;
    left: 6vh;
    top: 6vh;
    width: auto;
    background-color: transparent !important;
  }
  .burger-btn {
    position: relative;
    z-index: 999;
  }
  .telefono2 {
    right: 200px !important;
  }
}

@media (max-width: 960px) {
  .transicion {
    background-image: url("../src/assets/fondo-menu.png");
    /*background: linear-gradient(rgba(255,255,255,.5), rgba(255,255,255,.5)), url("../src/assets/fondo-menu.jpg");*/
    height: 100vh; /* You must set a specified height */
    top: 0%;
    left: 0%;
    background-position: left; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    transition: 725ms cubic-bezier(0.445, 0.05, 0.015, 1);
    z-index: 20;
  }
  .menu-item {
    position: relative;
    left: 1em;
    opacity: 0.7;
    border-bottom: 0px !important;
    transition: opacity 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .transicion:hover {
    transition: 725ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .bottom {
    position: absolute;
    z-index: 1;
    width: 90%;
    left: 5%;
    bottom: 3vh;
  }
  .bottom-up {
    padding-bottom: 0px;
  }
  .contacto {
    font-family: "Source";
    position: absolute;
    right: 0%;
    line-height: 1.5em;
    font-size: calc(10.75px + 0.7813vw);
  }
  .menu-titulos {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 40%;
    transition: opacity 325ms cubic-bezier(0.445, 0.05, 0.015, 1);
  }
  .column {
    width: 100%;
  }
  .column1 {
    line-height: 1;
    height: 12vh;
  }
  .row2 {
    height: 3vh;
  }

  .logo-menu {
    width: 30vw;
    height: 30vh;
    left: 35vw;
    top: 10vh;
  }
  .logo-menu3 {
    position: fixed;
    top: 1vh;
    left: 5vw;
    width: 10vw;
    height: 10vh;
  }
  .img-row {
    position: absolute;
    top: 0%;
    align-content: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
  .burger {
    top: 1.5vh;
    right: 1.5vh;
    z-index: 999;
    width: auto;
    background-color: transparent !important;
  }
  .burger-btn {
    position: relative;
    z-index: 999;
  }
  .telefono2 {
    right: 120px !important;
  }
}
</style>
